import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import persist from '@alpinejs/persist';

import select from './forms/select';
import form from './forms/form';
import mfaInput from './forms/mfaInput';
import textInput from './forms/textInput';
import countdown from './countdown';
import filters from './forms/filters';
import favourites from './favourites';
import propertyMap from './propertyMap';
import searchWidget from './searchWidget';
import recaptcha from './forms/recaptcha';
import cart from './cart';
import popover from './popover';

document.addEventListener('alpine:init', () => {
  Alpine.plugin(intersect);
  Alpine.plugin(persist);
  Alpine.data('select', select);
  Alpine.data('form', form);
  Alpine.data('mfaInput', mfaInput);
  Alpine.data('textInput', textInput);
  Alpine.data('countdown', countdown);
  Alpine.data('filters', filters);
  Alpine.data('favourites', favourites);
  Alpine.data('propertyMap', propertyMap);
  Alpine.data('searchWidget', searchWidget);
  Alpine.data('recaptcha', recaptcha);
  Alpine.data('cart', cart);
  Alpine.data('popover', popover);
  Alpine.store('isCartLoaded', false);
});

window.Alpine = Alpine;

Alpine.start();
